export const formatSecondaryProducts = (payload) => {
  const data = Object.entries(payload.data.product).reduce((obj, product) => {
    if (!product) return obj;
    const key = product[0] ?? false;
    const value = product[1]?.value ?? false;
    if (!key || !value) return obj;

    let parsedArray = JSON.parse(value.replace(/'/g, '"')) ?? [];
    const containsItems = parsedArray.length > 0;
    if (containsItems) {
      parsedArray = parsedArray.map((value) => {
        if (value === '') return false;
        if (value === 'true' || value === 'false') return JSON.parse(value);

        return value;
      });
    }

    obj[key] = parsedArray;

    return obj;
  }, {});

  return data;
};

export const formatID = (id) => {
  const matchType = ['ProductVariant/', 'Product/', 'Collection/'].find((match) => id.includes(match));
  return matchType ? parseInt(id.split(matchType)[1].trim()) : id;
};

export const parseTag = (tags, key) => {
  return tags
    .find((tag) => tag.includes(key))
    ?.split(':')[1]
    ?.trim();
};
